export const formatDeliveryDate = (date: Date) =>
  date.toLocaleDateString('us-EN', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
